import React from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const ToggleMenu = ({ isOpen, setOpen }) => (
  <S.ToggleButton
    aria-label="Menu"
    onClick={() => setOpen(!isOpen)}
    className={`menu-${isOpen ? 'opened' : 'closed'}`}
  >
    <S.ToggleBar />
    <S.ToggleBar />
    <S.ToggleBar />
  </S.ToggleButton>
)

ToggleMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
}

export default ToggleMenu
